import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot } from '@fortawesome/free-solid-svg-icons';

// Renderizar WhatsApp preview simulado
const renderSimulatedPreview = text => {
    if (!text) return '';
    return text
        .replace(/\{idTicket\}/g, '4892')
        .replace(/\{minutosEstimados\}/g, '5')
        .replace(/\{horarioAtencion\}/g, 'Lunes a Viernes de 9:00 a.m. a 6:00 p.m.');
};

const AutomaticMessagePreviewModal = ({ message, onClose, isDark }) => {
    if (!message) return null;

    return (
        <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{ backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(2px)', zIndex: 1050 }}
        >
            <div className="modal-dialog modal-dialog-centered">
                <div
                    className="modal-content border-0 shadow-lg"
                    style={{
                        backgroundColor: isDark ? '#121e2d' : '#ffffff',
                        borderRadius: '12px'
                    }}
                >
                    <div
                        className="modal-header py-3 px-4 border-bottom"
                        style={{ borderColor: isDark ? '#233142' : '#e2e8f0' }}
                    >
                        <div className="d-flex align-items-center gap-2">
                            <div
                                className="d-flex align-items-center justify-content-center rounded-circle"
                                style={{
                                    width: '32px',
                                    height: '32px',
                                    backgroundColor: '#25d366',
                                    color: '#ffffff'
                                }}
                            >
                                <FontAwesomeIcon icon={faRobot} style={{ fontSize: '0.9rem' }} />
                            </div>
                            <div>
                                <h6 className="modal-title fw-bold mb-0" style={{ color: isDark ? '#f9fafd' : '#0f172a' }}>
                                    Vista Previa WhatsApp
                                </h6>
                                <small className="text-muted" style={{ fontSize: '0.72rem' }}>
                                    Categoría: {message.vClaveMensaje} {message.vNombreUsuario ? `• Asesor: ${message.vNombreUsuario}` : '• Global'}
                                </small>
                            </div>
                        </div>

                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                            style={{ filter: isDark ? 'invert(1)' : 'none' }}
                        />
                    </div>

                    <div
                        className="modal-body p-4"
                        style={{
                            backgroundColor: isDark ? '#0b141a' : '#efeae2',
                            backgroundImage: isDark
                                ? 'radial-gradient(#1f2c34 1px, transparent 1px)'
                                : 'radial-gradient(#d1d7db 1px, transparent 1px)',
                            backgroundSize: '16px 16px',
                            borderRadius: '0 0 12px 12px'
                        }}
                    >
                        <div className="small text-center mb-3">
                            <span
                                className="badge rounded-pill px-2.5 py-1"
                                style={{
                                    backgroundColor: isDark ? 'rgba(30, 41, 59, 0.85)' : 'rgba(255, 255, 255, 0.9)',
                                    color: isDark ? '#94a3b8' : '#64748b',
                                    fontSize: '0.72rem',
                                    boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
                                }}
                            >
                                Hoy
                            </span>
                        </div>

                        <div className="d-flex justify-content-start">
                            <div
                                className="p-3 shadow-sm position-relative"
                                style={{
                                    maxWidth: '90%',
                                    backgroundColor: isDark ? '#202c33' : '#ffffff',
                                    color: isDark ? '#e9edef' : '#111b21',
                                    borderRadius: '0 10px 10px 10px',
                                    fontSize: '0.88rem',
                                    lineHeight: '1.5',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word'
                                }}
                            >
                                {renderSimulatedPreview(message.vMensajePersonalizado)}

                                <div
                                    className="text-end mt-1"
                                    style={{
                                        fontSize: '0.68rem',
                                        color: isDark ? '#8696a0' : '#667781'
                                    }}
                                >
                                    {new Date().toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit', hour12: true })}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className="modal-footer py-2.5 px-4 border-top"
                        style={{ borderColor: isDark ? '#233142' : '#e2e8f0' }}
                    >
                        <button
                            type="button"
                            className="btn btn-sm btn-secondary rounded-pill px-3 shadow-none"
                            onClick={onClose}
                            style={{ fontSize: '0.84rem' }}
                        >
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AutomaticMessagePreviewModal;
